export const getDefault = ({ color = '#92D200' } = {}) => {
  const schema = {
    name: 'Contests',
    backgroundColor: '#F1F1F2',
    activeColor: color,
    textColor: '#000',
    title: 'Concursos',
    resource: 'app.organism.contests.title',
    showHeader: true,
    contestType: 1,
    statesToIgnore: [1, 5],
    states: [],
    tabs: []
  }
  return schema
}
